import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import type { TypedUseSelectorHook } from "react-redux";
import fanpageReducer from "@features/channels/fanpageSlice";
import zaloReducer from "@features/channels/zaloSlice";
import messagesReducer from "@features/messages/messagesSlice";
import tagsReducer from "@features/tags/tagsSlice";
import agentsReducer from "@features/agents/agentsSlice";

export const store = configureStore({
  reducer: {
    fanpage: fanpageReducer,
    zalo: zaloReducer,
    messages: messagesReducer,
    tags: tagsReducer,
    agents: agentsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [],
        ignoredActionPaths: [],
        ignoredPaths: [],
      },
    }),
  devTools: import.meta.env.DEV,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
